import React, { FC } from 'react';
import BrandButton from '../../../../UI/common/brandButton';

import cardImg from './img/cardImage.jpg';
import alertImg from './img/alert.png';
import * as S from './styled';
import Popup from '../../../../UI/common/Popup';
import { SkipButton } from './components';
import { SpinLoader } from '../../../paywall/components/promocodeAnimated/spinLoader';
import { useT } from '@hooks';

interface Props {
	title?: string;
	text?: string;
	buttonText?: string;
	onButtonClick?: () => void;
	mailTo?: string;
	mailSubject?: string;
	active: boolean;
	setActive: (value: boolean) => void;
	showSkipButton?: boolean;
	isLoading?: boolean;
	loadingTitle?: string;
	loadingText?: string;
}

const PaymentErrorModal: FC<Props> = props => {
	const { T } = useT();
	const {
		title = T('payment_error_title'),
		text = T('payment_error_text'),
		buttonText = T('payment_error_support'),
		onButtonClick,
		mailTo = 'support@verv.health',
		mailSubject = 'After a successful purchase, I do not receive an activation code',
		active,
		setActive,
		showSkipButton,
		isLoading,
		loadingText = T('payment_error_loading_text'),
		loadingTitle = T('payment_error_loading_title'),
	} = props;

	return (
		<Popup active={active} setActive={setActive}>
			<S.PaymentModal>
				<S.CardContainer>
					<S.Image src={cardImg} />
					{isLoading ? (
						<S.Loader>
							<SpinLoader color='#fcfcfc' />
						</S.Loader>
					) : (
						<S.AlertImage src={alertImg} />
					)}
				</S.CardContainer>
				<S.Title>{isLoading ? loadingTitle : title}</S.Title>
				<S.Text>{isLoading ? loadingText : text}</S.Text>
				<S.ButtonsContainer isLoading={isLoading}>
					{onButtonClick == null ? (
						<S.Link href={`mailto:${mailTo}?subject=${mailSubject}`}>
							<BrandButton
								type='submit'
								disabled={false}
								animateButton={false}
								onClick={() => setActive?.(false)}
							>
								{buttonText}
							</BrandButton>
						</S.Link>
					) : (
						<BrandButton
							type='submit'
							disabled={false}
							animateButton={false}
							onClick={onButtonClick}
						>
							{buttonText}
						</BrandButton>
					)}
					{showSkipButton && (
						<S.SkipWrapper>
							<SkipButton onClick={() => setActive?.(false)} />
						</S.SkipWrapper>
					)}
				</S.ButtonsContainer>
			</S.PaymentModal>
		</Popup>
	);
};

export default PaymentErrorModal;
